"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/ShareOverlay.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _ui = require('web/services/ui');
var _uiUtils = require('web/components/VideoCall/OnCall/uiUtils');

const btnClassNames = [
  "blmh-button",
  "video-call--button",
  "video-call--on-call--share-btn",
]
const secondaryBtnClassName = _classBuilder2.default.call(void 0, 
  btnClassNames,
  "video-call--on-call--share-btn--secondary",
)









const ShareOverlay = ({
  roomLink, onRoomLinkCopy,
  onRoomShare, isNativeSharingAvailable,
  ignoredUIEvents,
}) => {
  const rootRef = _uiUtils.useStopPropagation.call(void 0, ignoredUIEvents)
  const linkTextRef = _react.useRef(null)

  const handleRoomLinkClick = async () => {
    await onRoomLinkCopy()
    // Selecting a missing node rejects, as in JS.
    return _ui.selectTextNode.call(void 0, linkTextRef.current)
  }

  return (
    _react2.default.createElement('div', { ref: rootRef, className: "video-call--on-call--share-overlay blm--allow-select" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      , _react2.default.createElement('span', { className: "video-call--on-call--share-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "You are the only person in this room."

      )
      , _react2.default.createElement('div', {
        onClick: handleRoomLinkClick,
        className: "video-call--on-call--share-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}

        , _react2.default.createElement('img', { src: "/assets/icons/video/link-white.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}} )
        , _react2.default.createElement('span', { ref: linkTextRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  roomLink )
      )
      , _react2.default.createElement('div', { className: "video-call--on-call--share-btns", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        , _react2.default.createElement('a', {
          className: secondaryBtnClassName,
          onClick: isNativeSharingAvailable ? onRoomShare : onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}

          ,  isNativeSharingAvailable
            ? _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('img', { src: "/assets/icons/video/share.svg", alt: "^", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}} ), "Share link"

              )
            : _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('img', { src: "/assets/icons/video/copy-white.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}} ), "Copy link"

              )
          
        )
      )
    )
  )
}

exports. default = ShareOverlay
